module.exports = __webpack_public_path__ + "images/emoji/interrobang.bbaedd378a8183bacaa6.png";